module.exports = __webpack_public_path__ + "img/icon.da66245f.png";